import React, { useCallback, useMemo } from "react";

import { Link, useHistory } from "react-router-dom";

import { HouseholdMember } from "@fartherfinance/frontend/api/Households/types";

import { getClientFullName } from "../utils";
import Text from "@src/sharedComponents/Typography/Text";

interface HouseholdMembersLinkProps {
  member: HouseholdMember;
}

const HouseholdMembersLink: React.FC<HouseholdMembersLinkProps> = ({
  member,
}) => {
  const history = useHistory();

  const handleClick = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      e.preventDefault();
      if (member) {
        const location = history.location;
        history.push({
          ...location,
          pathname: `/Advisor/Clients/${member.clientId}`,
        });
      }
    },
    [history, member]
  );

  const fullname = useMemo(() => {
    return `${getClientFullName(member)} ${
      member.memberType !== "Owner" ? `(${member.memberType})` : ""
    }`;
  }, [member]);

  return (
    <Link to={`/Advisor/Clients/${member.clientId}`}>
      <Text onClick={handleClick}>{fullname}</Text>
    </Link>
  );
};

export default HouseholdMembersLink;
